import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core/dist/esm/es6/rendering/cellRenderers/iCellRenderer';
import { Component } from '@angular/core';
import { environment } from '@env/environment';
import { getCachedImage } from '../../../../util/get-cached-image';

@Component({
    selector: 'app-distribution-tracking-channel-logo-renderer',
    templateUrl: './distribution-tracking-channel-logo-renderer.component.html',
    styleUrls: ['./distribution-tracking-channel-logo-renderer.component.scss'],
    standalone: false,
})
export class DistributionTrackingChannelLogoRendererComponent implements ICellRendererAngularComp {
    protected displayValue!: string | null | undefined;
    protected isDisplayIcon!: boolean;
    protected iconUrl?: string | undefined;
    protected baseUrl = environment.BASE_URL.substring(0, environment.BASE_URL.length - 1); //Removed last forward slash
    protected cachedLogoUrl!: string;
    linkUrl: string | undefined;

    agInit(params: ICellRendererParams & { linkUrl: string }): void {
        this.isDisplayIcon = params.data.channelName !== undefined;
        this.displayValue = params.valueFormatted;
        this.iconUrl = this.isDisplayIcon ? params.data.channelLogoUrl : undefined;
        this.linkUrl = params.linkUrl ? params.linkUrl : undefined;
        if (this.iconUrl) {
            getCachedImage(this.baseUrl + this.iconUrl).then((data) => {
                this.cachedLogoUrl = data;
            });
        }
    }

    refresh(params: ICellRendererParams): boolean {
        return false;
    }
}
